export default __webpack_public_path__ + "static/media/6_empresas-grandes.3b9bd78c.webp";